import React, { useState, useEffect } from "react";
import { useDispatch, UseDispatch, useSelector } from "react-redux";
import {
  LineChart,
  Line,
  XAxis,
  YAxis,
  CartesianGrid,
  Tooltip,
  Legend,
  ResponsiveContainer,
} from "recharts";

import {
  Port1Status,
  Port1Error,
  Port1UpdatedTime,
  Port1Loading,
  fetchAsyncPort1Info,
} from "./Port1Slice";

import { PeriodType } from "./Port1View";

//propsのinterface
interface Port1Props {
  period: PeriodType;
}

const Port1Graph = ({ period }: Port1Props) => {
  //storeにアクセス
  //データ
  const [data, setData] = useState<string[]>();
  const Port1InfoData = useSelector(Port1Status);

  const dispatch = useDispatch();

  //periodの状態に応じてグラフを切り替える
  useEffect(() => {
    if (Port1InfoData) {
      if (period === "累計") {
        setData(Port1InfoData.total);
      } else if (period === "今月") {
        setData(Port1InfoData.this_month);
      } else if (period === "先月") {
        setData(Port1InfoData.last_month);
      }
    }
  }, [period, Port1InfoData]);

  useEffect(() => {
    // 初回描画時に実行する処理
    dispatch(fetchAsyncPort1Info());

    // 定期実行を設定
    const interval = setInterval(() => {
      dispatch(fetchAsyncPort1Info());
    }, 60000); // 60秒ごとに実行

    // コンポーネントのクリーンアップ時にインターバルをクリア
    return () => clearInterval(interval);
  }, [dispatch]); // 依存配列にdispatchを含める

  return (
    <ResponsiveContainer width="100%" height="100%">
      <LineChart
        layout="vertical"
        width={500}
        height={300}
        data={data}
        margin={{
          top: 40,
          right: 10,
          left: 140,
          bottom: 5,
        }}>
        <CartesianGrid strokeDasharray="3 3" />
        <XAxis dataKey="返却件数" type="number" />
        <XAxis dataKey="貸出件数" type="number" />
        <YAxis
          dataKey="port_name"
          type="category"
          // onClick={(e) => setPortHandle(e)}
        />
        <Tooltip />
        <Legend />
        <Line dataKey="貸出件数" stroke="#8884d8" />
        <Line dataKey="返却件数" stroke="#82ca9d" />
      </LineChart>
    </ResponsiveContainer>
  );
};
export default Port1Graph;
